<se-fe-page
  [seFeDataLoaded]="ready"
  class="app-shipping-form"
  [ngClass]="{routedFlow: routedFlow}">
  <div seFePageContent>
    <se-fe-header seFeDataTitle="Address"></se-fe-header>
    <section #formScrollAnchor class="app-shipping-form">
      @if (ready) {
        <form
          [formGroup]="shippingForm"
          (ngSubmit)="continue()"
          data-cy="shipping-form"
          novalidate
          class="app-shipping-form__form">
          @if (!!shippingForm.errors) {
            <se-fe-alert seFeDataType="error">
              Review your address
              <se-fe-alert-subheader>
                We couldn't verify your address. Please make sure it's correct
                before continuing.
              </se-fe-alert-subheader>
            </se-fe-alert>
          }
          <div class="app-shipping-form__names">
            <div class="app-shipping-form__names-first">
              <se-fe-form-field [seFeDataConfig]="formFieldsConfig.firstName">
                <se-fe-form-field-text
                  formControlName="firstName"
                  seFeDataPlaceholder="First Name"></se-fe-form-field-text>
              </se-fe-form-field>
            </div>
            <div class="app-shipping-form__names-last">
              <se-fe-form-field [seFeDataConfig]="formFieldsConfig.lastName">
                <se-fe-form-field-text
                  formControlName="lastName"
                  seFeDataPlaceholder="Last Name"></se-fe-form-field-text>
              </se-fe-form-field>
            </div>
          </div>
          <div
            class="app-shipping-form__address-group"
            [ngClass]="{
              'address-group-error': !!shippingForm.errors,
            }">
            <div class="app-shipping-form__address">
              <div class="app-shipping-form__address-1">
                <se-fe-form-field [seFeDataConfig]="formFieldsConfig.address1">
                  <se-fe-form-field-text
                    formControlName="address1"
                    seFeDataPlaceholder="123 Main Street"></se-fe-form-field-text>
                </se-fe-form-field>
              </div>
              <div class="app-shipping-form__address-2">
                <se-fe-form-field [seFeDataConfig]="formFieldsConfig.address2">
                  <se-fe-form-field-text
                    formControlName="address2"
                    seFeDataPlaceholder="Enter your apartment, suite, or unit number"></se-fe-form-field-text>
                </se-fe-form-field>
              </div>
            </div>
            <div class="app-shipping-form__country">
              <se-fe-form-field [seFeDataConfig]="formFieldsConfig.country">
                <se-fe-form-field-select
                  formControlName="country"
                  [seFeDataOptions]="countries"
                  seFeDataPlaceholder="Country"
                  [seFeDataAllowClear]="false"
                  seFeDataAriaLabel="Country"></se-fe-form-field-select>
              </se-fe-form-field>
            </div>
            <div class="app-shipping-form__local">
              <div class="app-shipping-form__local-city">
                <se-fe-form-field [seFeDataConfig]="formFieldsConfig.city">
                  <se-fe-form-field-text
                    formControlName="city"
                    seFeDataPlaceholder="City"></se-fe-form-field-text>
                </se-fe-form-field>
              </div>
              <div class="app-shipping-form__local-state">
                <se-fe-form-field [seFeDataConfig]="formFieldsConfig.state">
                  <se-fe-form-field-select
                    formControlName="state"
                    [seFeDataOptions]="states"
                    seFeDataPlaceholder="State"
                    [seFeDataAllowClear]="false"
                    seFeDataAriaLabel="State"></se-fe-form-field-select>
                </se-fe-form-field>
              </div>
              <div class="app-shipping-form__local-zip">
                <se-fe-form-field [seFeDataConfig]="formFieldsConfig.zip">
                  <se-fe-form-field-text
                    formControlName="zip"
                    seFeDataPlaceholder="Zip code"></se-fe-form-field-text>
                </se-fe-form-field>
              </div>
            </div>
          </div>
        </form>
      }
    </section>
    <se-fe-footer>
      <p class="disclaimer">
        By completing this registration, you agree to SportsEngine's
        <a
          href="https://www.sportsengine.com/privacy-center/privacy-policy/"
          target="_blank">
          privacy policy
        </a>
        , including sharing your personal data with third-party partners for the
        purposes of fulfilling and/or shipping items included in this
        registration.
      </p>
      <se-fe-button
        [seFeDataIsLoading]="shippingForm.status === 'PENDING'"
        [seFeDataIsDisabled]="hasAddressError"
        seFeDataEmphasis="high"
        [seFeDataFullWidth]="(breakpointUtils.smallScreen$ | async) ?? false"
        (click)="continue()">
        Continue
      </se-fe-button>
    </se-fe-footer>
  </div>
</se-fe-page>
